import React from "react";
import { BookOpen, Shield, Sparkles, Heart } from "lucide-react";

const LaurelIcon = ({ className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M32 52 C22 42 18 30 20 18" />
    <path d="M32 52 C42 42 46 30 44 18" />
    <path d="M22 22 C18 22 15 20 14 17" />
    <path d="M23 28 C19 28 16 26 15 23" />
    <path d="M25 35 C21 35 18 33 17 30" />
    <path d="M28 42 C24 42 21 40 20 37" />
    <path d="M42 22 C46 22 49 20 50 17" />
    <path d="M41 28 C45 28 48 26 49 23" />
    <path d="M39 35 C43 35 46 33 47 30" />
    <path d="M36 42 C40 42 43 40 44 37" />
    <circle cx="32" cy="14" r="1.6" fill="currentColor" />
  </svg>
);

const FlameHeartIcon = ({ className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M32 54 C18 44 12 34 16 26 C19 20 26 20 32 27 C38 20 45 20 48 26 C52 34 46 44 32 54 Z" />
    <path d="M32 20 C30 16 32 12 34 10 C33 14 36 15 35 19 C34 22 32 22 32 20 Z" fill="currentColor" stroke="none" />
  </svg>
);

const CrossShieldIcon = ({ className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 14 L32 10 L50 14 V32 C50 44 42 52 32 56 C22 52 14 44 14 32 Z" />
    <path d="M32 22 V42" stroke="#c9a961" />
    <path d="M25 29 H39" stroke="#c9a961" />
  </svg>
);

const BookIcon = ({ className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 16 C18 14 26 14 32 18 C38 14 46 14 54 16 V50 C46 48 38 48 32 52 C26 48 18 48 10 50 Z" />
    <path d="M32 18 V52" />
    <path d="M16 24 H26" />
    <path d="M16 30 H26" />
    <path d="M16 36 H26" />
    <path d="M38 24 H48" />
    <path d="M38 30 H48" />
    <path d="M38 36 H48" />
  </svg>
);

const columns = [
  {
    id: "academics",
    title: "Rigorous Academics",
    body:
      "A classical curriculum that develops thinkers, diligent workers, and lifelong learners.",
    img: "/assets/open-book.png",
  },
  {
    id: "faith",
    title: "Deep Faith Formation",
    body:
      "Catholic faith is the heart of all we do, forming students in virtue and a love for Christ and His Church.",
    img: "/assets/cross-shield.png",
  },
  {
    id: "beauty",
    title: "Beauty & Joy",
    body:
      "Cultivating wonder, gratitude, and friendship through the beautiful things that form the soul.",
    img: "/assets/laurel-wreath.png",
  },
  {
    id: "fatima",
    title: "Fatima Spirituality",
    body:
      "Named for the Angel that appeared to the children at Fatima and consecrated to the Immaculate Heart of Mary, we teach our students to strive for holiness through prayer, penance, and reparation.",
    img: "/assets/sacred-heart.png",
  },
];

const FeatureColumns = () => {
  return (
    <section id="about" className="bg-[#fbf7ee] border-t border-[#eae1c4]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-0">
          {columns.map((col, idx) => (
            <div
              key={col.id}
              className={`text-center px-4 lg:px-8 ${idx > 0 ? "lg:col-rule" : ""} relative`}
              style={idx > 0 ? undefined : undefined}
            >
              {idx > 0 && (
                <span className="hidden lg:block absolute left-0 top-[10%] bottom-[10%] w-px bg-[#c9a961]/50" />
              )}
              <div className="icon-wrap flex items-center justify-center mb-6 text-[#1e2952]" style={{ minHeight: "88px" }}>
                {col.img ? (
                  <img src={col.img} alt="" className="h-20 w-auto object-contain" />
                ) : (
                  <col.Icon className="w-14 h-14" />
                )}
              </div>
              <h3 className="font-sans-nav text-[13px] tracking-[0.24em] uppercase text-[#1e2952] font-semibold mb-4">
                {col.title}
              </h3>
              <p className="font-serif-body text-[#3a466e] text-[16px] leading-[1.65] max-w-[260px] mx-auto">
                {col.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureColumns;
